import { 
  doc, 
  getDoc, 
  setDoc, 
  serverTimestamp 
} from 'firebase/firestore';
import { database as db } from '../config/firebase';

export interface SimpleSettings {
  // Basic CMS Info
  siteTitle: string;
  siteDescription: string;
  
  // Notification Settings
  enableNotifications: boolean;
  notificationEmail: string;
  
  // Content Defaults
  defaultPublishStatus: boolean;
  
  // Last Updated
  lastUpdated: Date;
}

class SettingsService {
  private settingsCollection = 'settings';
  private settingsDocId = 'cms_settings';

  async getSettings(): Promise<SimpleSettings> {
    try {
      const settingsRef = doc(db, this.settingsCollection, this.settingsDocId);
      const settingsSnap = await getDoc(settingsRef);

      if (settingsSnap.exists()) {
        const data = settingsSnap.data();
        return {
          siteTitle: data.siteTitle || 'Aatma ki Yatra CMS',
          siteDescription: data.siteDescription || 'Content Management System',
          enableNotifications: data.enableNotifications ?? true,
          notificationEmail: data.notificationEmail || 'admin@aatmakiyatra.com',
          defaultPublishStatus: data.defaultPublishStatus ?? false,
          lastUpdated: data.lastUpdated?.toDate() || new Date()
        };
      } else {
        // Return default settings
        return this.getDefaultSettings();
      }
    } catch (error) {
      console.error('Error fetching settings:', error);
      return this.getDefaultSettings();
    }
  }

  async updateSettings(settings: Partial<SimpleSettings>): Promise<void> {
    try {
      const settingsRef = doc(db, this.settingsCollection, this.settingsDocId);
      
      const updateData = {
        ...settings,
        lastUpdated: serverTimestamp()
      };

      await setDoc(settingsRef, updateData, { merge: true });
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error;
    }
  }

  private getDefaultSettings(): SimpleSettings {
    return {
      siteTitle: 'Aatma ki Yatra CMS',
      siteDescription: 'Content Management System',
      enableNotifications: true,
      notificationEmail: 'admin@aatmakiyatra.com',
      defaultPublishStatus: false,
      lastUpdated: new Date()
    };
  }
}

export const settingsService = new SettingsService();